import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { reducePolicyValidationInfo } from '../../actions/policy/reducePolicyValidationInfo';
import { selectEntity } from '../../selectors/policy/selectEntity';

export function* getPolicyValidationInfoSaga() {
    try {
        yield put(reduceLoading({ code: 'getPolicyValidationInfo', value: true }));
        const session = yield getSessionSaga();
        const entity = yield select(selectEntity());

        const response = yield call(fetch, `/api/policyTransaction/validationInfo/${entity}`, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
        });

        const result = yield call([response, 'json']);

        yield put(reduceOperation(result.operation));
        if (!result.operation?.status) return;

        yield put(reducePolicyValidationInfo(result.policyTransactionValidationInfo));
    } catch (error) {
        console.log('Error while calling Get Policy Validation Information API - ', error);
    } finally {
        yield put(reduceLoading({ code: 'getPolicyValidationInfo', value: false }));
    }
}
